<template>
  <div>
    <van-search
      v-model="keyword"
      show-action
      label="货号"
      placeholder="请输入订单货号"
      @search="onSearch"
    >
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>
    <div class="order-show" v-show="orderShow">
      <div class="order-show-li">
        <h3 class="h3">订单信息</h3>
        <div class="o-s-li-m">
          <span>订单编号：{{ codeData.order_sn }}</span>
          <span>下单日期：{{ codeData.created_at }}</span>
          <span>扫码日期：{{ codeData.updated_at }}</span>
        </div>
      </div>
      <div class="order-show-li">
        <h3 class="h3">用户信息</h3>
        <div class="o-s-address">
          <p>ID：{{ codeData.user_id }}</p>
          <p>姓名：{{ codeData.user_name }}</p>
        </div>
      </div>
      <div class="order-show-li">
        <h3 class="h3">绑定防伪码</h3>
        <div class="o-s-address">
          <p v-for="code in codeData.codes" :style="{'color':keyword == code.code ? 'red':'black'}">防伪码：{{ code.code }}</p>
        </div>
      </div>
    </div>
    <wxNoShare />
    <Footer />
  </div>
</template>

<script>
  import { Search } from 'vant';

  export default {
    components: {
      [Search.name]: Search,
    },
    name: 'orders',
    data() {
      return {
        keyword: '',
        orderShow: false,
        codeData: []
      }
    },
    created() {

    },
    methods: {
      getOrders() {
        this.$api.get('fw/codeSearch', {keyword: this.keyword}, r=>{
          this.codeData = r.result
          if(r.result.id){
            this.orderShow = true
          }else{
            this.orderShow = false
          }
        })
      },
      onSearch() {
        // this.$toast('搜索' + this.keyword)
        this.getOrders()
      },
    }
  }
</script>

<style scoped>
  .order-show{
    padding:10px;
    overflow: hidden;
  }
  .order-show-li{
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    padding:10px;
    margin-bottom: 10px;
  }
  .order-show-li .h3{
    margin: 0;
    font-size: 14px;
    padding-bottom: 5px;
  }
  .order-show-li .o-s-li-m{
    font-size: 14px;
  }
  .order-show-li .o-s-li-m span{
    display: block;
    line-height: 30px;
  }

  .order-show-li .o-main{
    overflow: hidden;
    margin-top: 5px;
  }
  .order-show-li .o-main .img{
    float: left;
    width: 35%;
  }
  .order-show-li .o-main .img img{
    width: 100%;
    height: 80px;
  }
  .order-show-li .o-main .info{
    float: right;
    width: 60%;
    margin-left: 5%;
  }
  .order-show-li .o-main .info h3{
    margin: 0;
    font-size: 14px;
    font-weight: normal;
    height: 40px;
  }
  .order-show-li .o-main .info .price{
    font-size: 14px;
  }
  .order-show-li .o-main .info .price .sp2{
    color:#646566;
  }
  .order-show-li .o-main .info .pay-price{
    font-size: 14px;
    margin-top: 5px;
  }
  .order-show-li .o-main .info .pay-price .p-sp-2{
    float: right;
  }
  .order-show-li .o-s-address{
    font-size: 14px;
  }
  .order-show-li .o-s-address p{
    margin: 8px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/index/search.vue